var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66666C10.1187 2.66666 5.33336 7.45199 5.33336 13.3267C5.29469 21.92 15.5947 29.0453 16 29.3333C16 29.3333 26.7054 21.92 26.6667 13.3333C26.6667 7.45199 21.8814 2.66666 16 2.66666ZM16 18.6667C13.0534 18.6667 10.6667 16.28 10.6667 13.3333C10.6667 10.3867 13.0534 7.99999 16 7.99999C18.9467 7.99999 21.3334 10.3867 21.3334 13.3333C21.3334 16.28 18.9467 18.6667 16 18.6667Z",
    fill: "#3E4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomMap);
export default __webpack_public_path__ + "static/media/custom_map.4b64d2558d56fb9b690c32bd8671fe60.svg";
export { ForwardRef as ReactComponent };